<template>
  <div class="base-switch">
    <div class="base-switch__list">
      <div
        v-for="[option, index] in options"
        :key="index"
        class="base-switch__item"
        :class="{ 'is-active': option === value }"
        @click="handleChange(option)"
      >
        <div class="base-switch__control">
          <span class="base-switch__label">
            <slot>{{ option }}</slot>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSwitch',
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleChange(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.base-switch {
  display: inline-block;
}

.base-switch__list {
  display: flex;
}

.base-switch__item {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  padding: 0 22px;
  user-select: none;
  cursor: pointer;
  border-radius: 5px 0 0 5px;
  border: 1px solid $color-deep-soft-blue;
}

.base-switch__item:first-child {
  border-radius: 5px 0 0 5px;
}

.base-switch__item:last-child {
  border-radius: 0 5px 5px 0;
  border-left-color: transparent;
}

.base-switch__item.is-active {
  box-shadow: 0 5px 10px rgba(81, 84, 89, 0.15);
}
</style>
